import Panel from "components/panels/panel";
import React from "react";
import { useCustomQuery } from "utilities/hookutils";
import DocumentFromTemplateRowCard from "./TemplateRow";
import { type AxiosPromise } from "axios";
import { apiResponse } from "utilities/apiUtils";

interface Props {
  itemId: number
  api: (itemId: number) => AxiosPromise<server.dto.ApiResponseWrapper<server.dto.ExportOption[]>>
  panelTitle?: string
}

const DocumentFromTemplatePanel = (props: Props) => {
  const query = useCustomQuery({
    queryFn: async () => props.api(props.itemId).then(response => response.data),
    queryKey: ["DocumentFromTemplateAppForShow", props.itemId],
    initialData: apiResponse.success([])
  });

  // Hide the panel while loading, because otherwise it will flicker in and out of existence
  if (query.isLoading) {
    return <></>;
  }

  // Don't show the panel if there are no export options
  if (query.data.data.length === 0) {
    return <></>;
  }

  return <Panel
    panelClassName="s1_related-feature-panel"
    title={RESX.Template.GenerateDocumentFromTemplate}
    isLoading={query.isLoading}
    hasData={query.data != null && query.data.data.length > 0}
    hasError={query.isError || query.data.hasErrors}
  >
    <div className="list-with-gaps line-layout">
      <div className="list-with-gaps-body">
        {query.data.data.map((exportOption, idx) => (
          <DocumentFromTemplateRowCard
            key={idx}
            exportOption={exportOption}
          />
        ))}
      </div>
    </div>
  </Panel>;
};

export default DocumentFromTemplatePanel;